import { formatDateWithLocalTZ } from "@ticomix/common";
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from "rxjs";
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from "@angular/common/http";

import { ITokenRefreshRequest } from "./i-itoken-refresh-request";
import { throwException, blobToText } from "./api-utilities";

export class TokenRefreshRequest implements ITokenRefreshRequest {
  RefreshToken!: string;

  constructor(data?: ITokenRefreshRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.RefreshToken = "";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.RefreshToken =
        _data["RefreshToken"] !== undefined ? _data["RefreshToken"] : "";
    }
  }

  static fromJS(data: any): TokenRefreshRequest {
    data = typeof data === "object" ? data : {};
    let result = new TokenRefreshRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["RefreshToken"] =
      this.RefreshToken !== undefined ? this.RefreshToken : <any>null;
    return data;
  }
}
